import * as AsyncActions from '@telstra-connect/standard-actions/async-action';

export interface IMobilityPexState {
    isAuthenticated: boolean;
    areScriptsLoaded: boolean;
    status: AsyncActions.AsyncActionState;
    error?: string;
}

export interface IMobilityPexRootState {
    mobilityPex: IMobilityPexState;
}

export enum MpexWebComponentEvents {
    orderCompletion = 'oncompletion',
    load = 'onload',
    viewChange = 'onviewchange',
    interaction = 'oninteraction',
    error = 'onerror',
}

export enum MpexWebComponentInteractions {
    goToHome = 'go_to_home'
}

export enum OrderSource {
    mpex = 'mpex'
}

export interface IMpexDynamic5gCustomerLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
    ref: React.MutableRefObject<HTMLDivElement>;
    cidn: string;
    orderId: string
    view?: string;
    caas?: object;
    layout?: object;
}
